import { Sparkles, Infinity as InfinityIcon, Circle } from 'lucide-react';

// Shows which plan the account is on. Rendered next to FoundingBadge wherever
// we show who the user is, so the two read as one row of account facts.
//
// `size`: 'sm' for tight spots (sidebar), 'md' for headers.
// `onDark`: use on the dashboard's dark green header.
const STYLES = {
    free: { label: 'Free', icon: Circle, onLight: 'bg-stone-100 text-stone-600 ring-stone-300' },
    pro: { label: 'Pro', icon: Sparkles, onLight: 'bg-emerald-100 text-emerald-800 ring-emerald-300', onDark: 'bg-emerald-400/25 text-emerald-100 ring-emerald-300/50' },
    unlimited: { label: 'Unlimited', icon: InfinityIcon, onLight: 'bg-amber-100 text-amber-800 ring-amber-300', onDark: 'bg-amber-400/25 text-amber-100 ring-amber-300/50' },
};

const PlanBadge = ({ plan, size = 'sm', onDark = false, className = '' }) => {
    const key = (plan || 'free').toLowerCase();
    const style = STYLES[key] || STYLES.free;
    const Icon = style.icon;
    const sm = size === 'sm';

    return (
        <span
            title={`${style.label} plan`}
            className={`inline-flex items-center gap-1 rounded-full font-semibold whitespace-nowrap ring-1 ring-inset ${
                sm ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'
            } ${
                // Pro/Unlimited keep their own colour on dark too, just
                // lightened for contrast against the dark green header. Free
                // has no colour to carry over, so it stays the neutral pill.
                onDark ? (style.onDark || 'bg-white/10 text-white/90 ring-white/20') : style.onLight
            } ${className}`}
        >
            <Icon className={`${sm ? 'h-2.5 w-2.5' : 'h-3 w-3'} ${key === 'free' ? '' : 'fill-current'}`} />
            {style.label}
        </span>
    );
};

export default PlanBadge;
